import React, { ForwardedRef } from 'react';
import { hofForwardRef } from '../../../utils/types';
import { GroupBase, mergeStyles, SelectInstance } from 'react-select';
import CreatableSelect, { CreatableProps } from 'react-select/creatable';
import { EmptyComponent, getDefaultStyles } from './SelectUtils';
import { onKeyDownPreventEnter } from './utils';
import { useFloatingLayerContext } from '../../FloatingManager';

export const ENTER_NEW_VALUE_HINT = 'Accept the manually entered value';

const defaultFormatCreateLabel = (inputValue: string) => (
  <div>
    <b>Entered: </b>
    <span>{inputValue}</span>
  </div>
);

export default hofForwardRef(
  <
    Option,
    IsMulti extends boolean = false,
    Group extends GroupBase<Option> = GroupBase<Option>,
  >(
    {
      styles,
      components,
      menuPlacement,
      placeholder,
      ...props
    }: CreatableProps<Option, IsMulti, Group>,
    ref: ForwardedRef<SelectInstance<Option, IsMulti, Group>>,
  ) => {
    const zIndex = useFloatingLayerContext();

    const selectStyles = mergeStyles(
      getDefaultStyles<Option, IsMulti, Group>(zIndex),
      styles,
    );
    return (
      <CreatableSelect
        {...props}
        ref={ref}
        // Creatable special properties
        formatCreateLabel={props?.formatCreateLabel ?? defaultFormatCreateLabel}
        allowCreateWhileLoading={true}
        isClearable={props?.isClearable ?? true}
        createOptionPosition="first"
        menuPlacement={menuPlacement || 'auto'}
        placeholder={placeholder || ''}
        styles={selectStyles}
        onKeyDown={props.onKeyDown || onKeyDownPreventEnter}
        components={{
          MultiValueRemove: EmptyComponent,
          DropdownIndicator: EmptyComponent,
          IndicatorSeparator: EmptyComponent,
          ClearIndicator: EmptyComponent,
          LoadingIndicator: EmptyComponent,
          ...components,
        }}
      />
    );
  },
);
